<div class="i-page-top">
  <div class="container">
    <!--Menu-->
    <div class="i-menu row align-items-center pt-3 pb-2">
      <div class="navbar-brand col-6 col-sm-8 col-md-6 col-lg-4 mr-auto py-2 px-0 text-center text-sm-left">
        <a href="#" routerLink="/home" aria-label="Private"
          ><img src="assets/img/logo_cinza.svg" class="img-fluid my-auto" alt="Private"
        /></a>
      </div>
      <div class="col-6 col-sm-4 col-md-6 col-lg-8 ml-auto py-2">
        <app-menu></app-menu>
      </div>
    </div>
  </div>
</div>
<div class="i-page-content">
  <div class="i-favorite container py-5">
    <div class="row text-center py-3">
      <h1 class="i-title mx-auto">MAPA DO SITE</h1>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">SOBRE</div>
        <div class="pt-3">
          <a href="#" routerLink="/institucional">Institucional</a><br />
          <ng-container *ngFor="let p of pages$ | async">
            <a [routerLink]="'/institucional/' + p.slug">{{ p.menu }}</a
            ><br />
          </ng-container>
          <a href="#" routerLink="/trabalhe-conosco">Trabalhe Conosco</a><br />
          <a href="#" href="https://blog.privateimoveis.com" target="_blank">Blog</a><br />
          <a href="#" routerLink="/contato">Contato</a><br />
          <a href="/politica-de-privacidade">Privacidade</a><br />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">EXPLORE</div>
        <div class="pt-3">
          <a href="#" routerLink="/imoveis/status/alugar">Alugar</a><br />
          <a href="#" routerLink="/imoveis/status/venda">Comprar</a><br />
          <a href="#" routerLink="/imoveis/agro">Agronegócio</a><br />
          <a href="#" routerLink="/imoveis/corporate">Corporate</a><br />
          <a href="#" routerLink="/imoveis/lancamentos">Lançamentos</a><br />
          <a href="#" routerLink="/imoveis/exclusividades">Exclusividades</a><br />
          <a href="#" routerLink="/imoveis/bola-da-vez">Bola da vez</a><br />
          <a href="#" routerLink="/contato/venda">Venda seu imóvel</a><br />
          <a href="#" routerLink="/contato/alugue">Alugue seu imóvel</a><br />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">CIDADES</div>
        <div class="pt-3">
          <a href="#" routerLink="/imoveis/status/venda/cidade/porto-alegre">Porto Alegre</a><br />
          <a href="#" routerLink="/imoveis/status/venda/cidade/sao-paulo">São Paulo</a><br />
          <!-- <ng-container *ngFor="let u of ufs$ | async">
                        <ng-container *ngFor="let c of u.cidades">
                            <a [routerLink]="'/imoveis/status/venda/cidade/' + c.slug">{{c.nome}}</a><br />
                        </ng-container>
                    </ng-container> -->
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">SEGUIR</div>
        <div class="pt-3">
          <a href="https://www.instagram.com/privateimobiliaria/" target="_blank" rel="noopener"> Instagram </a><br />
          <a href="https://www.instagram.com/privateimobiliaria_sp/" target="_blank" rel="noopener"> Instagram SP </a
          ><br />
          <a href="https://www.instagram.com/privateimoveisagro/" target="_blank" rel="noopener"> Instagram +AGRO </a
          ><br />
          <!-- <a href="https://www.facebook.com/privateimoveis" target="_blank" rel="noopener"> Facebook </a><br /> -->
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">PERFIL</div>
        <div class="pt-3">
          <a href="#" routerLink="/cadastre-se">Cadastre-se</a><br />
          <a href="#" routerLink="/login">Login</a><br />
          <a href="#" routerLink="/imoveis/favoritos">Favoritos</a><br />
          <a href="#" routerLink="/imoveis/descartados">Descartados</a><br />
          <a href="#" routerLink="/imoveis/comparar">Comparação</a><br />
          <a href="#" routerLink="/demonstrativos">Demonstrativo proprietário</a><br />
          <a href="#" routerLink="/boletos">2ª via de boletos</a><br />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">BUSCAR POR ÁREA</div>
        <div class="pt-3">
          <ng-container *ngFor="let v of [50, 100, 150, 250]">
            <a href="#" [routerLink]="'/imoveis/status/venda/cidade/' + cidadeSlug" [queryParams]="{ a1: v, a2: v * 2 }"
              >{{ v }} a {{ v * 2 }} m<sup>2</sup></a
            ><br />
          </ng-container>
          <a href="#" [routerLink]="'/imoveis/status/venda/cidade/' + cidadeSlug" [queryParams]="{ a1: 500 }"
            >500+ m<sup>2</sup></a
          ><br />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">BUSCAR POR VALOR</div>
        <div class="pt-3">
          <ng-container *ngFor="let v of [100000, 200000, 300000, 400000]">
            <a href="#" [routerLink]="'/imoveis/status/venda/cidade/' + cidadeSlug" [queryParams]="{ v1: v, v2: v * 2 }"
              >{{ v | R$: 0 }} a {{ v * 2 | R$: 0 }}</a
            ><br />
          </ng-container>
          <a href="#" [routerLink]="'/imoveis/status/venda/cidade/' + cidadeSlug" [queryParams]="{ v1: 1000000 }"
            >R$ 1.000.000+</a
          ><br />
        </div>
      </div>
    </div>
    <!-- <div class="row text-center py-3">
            <div class="col-12">
                <h1 class="i-title">IMÓVEIS</h1>
            </div>
        </div> -->
    <div class="row">
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">MAIS ACESSADOS</div>
        <div class="i-cities pt-3">
          <ng-container *ngFor="let p of hottest$ | async | slice: 0 : 5">
            <a [routerLink]="p.internalUrl">
              {{ p.categoria }} em {{ p.cidade }}<br />
              Bairro {{ p.bairro }} <br />
              {{ p.valor | R$: 0 }}
            </a>
            <hr />
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">DESTAQUES</div>
        <div class="i-cities pt-3">
          <ng-container *ngFor="let p of spots$ | async | slice: 0 : 5">
            <a [routerLink]="p.internalUrl">
              {{ p.categoria }} em {{ p.cidade }}<br />
              Bairro {{ p.bairro }} <br />
              {{ p.valor | R$: 0 }}
            </a>
            <hr />
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">LANÇAMENTOS</div>
        <div class="i-cities pt-3">
          <ng-container *ngFor="let p of releases$ | async | slice: 0 : 5">
            <a [routerLink]="p.internalUrl">
              {{ p.categoria }} em {{ p.cidade }}<br />
              Bairro {{ p.bairro }} <br />
              {{ p.valor | R$: 0 }}
            </a>
            <hr />
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle">RECENTES</div>
        <div class="i-cities pt-3">
          <ng-container *ngFor="let p of recents$ | async | slice: 0 : 5">
            <a [routerLink]="p.internalUrl">
              {{ p.categoria }} em {{ p.cidade }}<br />
              Bairro {{ p.bairro }} <br />
              {{ p.valor | R$: 0 }}
            </a>
            <hr />
          </ng-container>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-4 mb-4 py-4 py-md-5">
        <div class="i-subtitle pb-3">CORRETORES</div>
        <div class="row">
          <div class="col-3" *ngFor="let b of brokers$ | async">
            <a [routerLink]="b.url" target="_blank">{{ b.nome }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
